export default "__VITE_ASSET__ANW8RuhN__"